import React from 'react';
import { FAQGlobalReferenceType } from '../../../../types/FAQGlobalReferenceType';

interface SchemaFAQProps {
  faq: FAQGlobalReferenceType;
  url?: string;
}

const SchemaFAQ = ({ faq, url = '' }: SchemaFAQProps) => {
  if (!faq?.faqItems?.length) return null;

  const questions = faq.faqItems
    .map((item) => {
      const answerText = item.answer
        ? item.answer
            .map((block) => block.children?.map((child) => child.text).join('') || '')
            .join('\n')
            .replace(/"/g, '')
        : '';

      return `{
        "@type": "Question",
        "name": "${item.question || ''}",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "${answerText}"
        }
      }`;
    })
    .join(',');

  const structuredData = `{
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [${questions}],
    "url": "${url}"
  }`;

  return (
    <script
      type="application/ld+json"
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: structuredData }}
    />
  );
};

export default SchemaFAQ;
